package ui.themePlusContext

import react.FC
import react.Props
import react.useContext
import ui.component.switches.SwitchMassive

external interface ThemeSwitchProps : Props {
    var heightSize: Int
    var deleteTitle: Boolean
}

val themeSwitch = FC<ThemeSwitchProps>{props->
    val ctx = useContext(MyContext)
    val theme = ctx.themeMode
    val setTheme = ctx.setThemeMode
    val heightSize = props.heightSize.takeIf { it != undefined } ?: 75
    val dlTitle = props.deleteTitle.takeIf { it != undefined } ?: false

    SwitchMassive{
        if (!dlTitle){
            this.titleTextOrNull = "Выбрана ${theme.icon.description}"
        }
        this.titleTextForTitle = "Сменить на ${
            when (theme) {
                ThemesMode.LIGHT -> ThemesMode.DARK
                ThemesMode.DARK -> ThemesMode.LIGHT
            }.icon.description
        }"

        this.heightSize = heightSize
        this.checked = theme == ThemesMode.DARK

        this.switchIcon = when (theme) {
            ThemesMode.LIGHT -> ThemesMode.LIGHT
            ThemesMode.DARK -> ThemesMode.DARK
        }.icon
        this.onChange = {
            setTheme(
                when (theme) {
                    ThemesMode.LIGHT -> ThemesMode.DARK
                    ThemesMode.DARK -> ThemesMode.LIGHT
                }
            )
        }
    }
}